import BaseApi from "@/api/baseApi";

export default {
  printPreview(deliveries, context) {
    return BaseApi.post(`/api-piglet/api/delivery-print/preview/v1?context=${context}`, deliveries);
  },
  print(deliveries, context) {
    return BaseApi.post(`/api-piglet/api/delivery-print/print/v1?context=${context}`, deliveries);
  }
}
